/**
 * Base state for current module
 */
const state = {
  questions: [],
  my_questions: [],
  props: {
    limit: 10,
  },
  defaultProps: [
    {
      key: "limit",
      label: "Limit",
      helperText: "Select the number of items to view (max 30)",
      type: "text",
      value: 10,
      validation: "required:true|between:1,30",
    },
  ],
  largestQuerySize: 0,
  status: "WAITING",
};

export default state;
